export const accountSettingsLinks = [
    {
        id: 7,
        title: "Personal Info",
        text: "You know the drill. This is where you’ll update your username, contact information, and time zone.",
        link: "/account-settings/personal-info",
        soon: false,
        memberOnly: false
    },
    {
        id: 8,
        title: "Login & Security",
        text: "Set it but don’t forget it! Update your password or deactivate your account here.",
        link: "/account-settings/login-security",
        soon: false,
        memberOnly: false
    },
    {
        id: 9,
        title: "Payment Center",
        text: "This is where you'll view and manage your Zoee payment methods and transactions.",
        link: "/account-settings/payment-center",
        soon: false,
        memberOnly: false
    },
    {
        id: 10,
        title: "Calendar Settings",
        text: "Get connected. This is where you’ll connect your various calendar accounts for seamless scheduling.",
        link: "/account-settings/calendars",
        soon: false,
        memberOnly: true
    },
    {
        id: 11,
        title: "Notifications",
        text: "Want to change how we communicate? This is where you’ll decide when and how you’d like Zoee to ping you.",
        link: "/account-settings/notifications",
        soon: false,
        memberOnly: false
    }
]